import { BaseContainer } from "../helpers/baseContainer";

const baseContainer = new BaseContainer();

export { baseContainer };
